import { useCallback, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { TEMPLATE_GALLERY_PARAM } from '../constants';

export const useShowTemplateGalleryModal = () => {
  const history = useHistory();
  const [showing, setIsShowing] = useState(false);

  // When called this function only sets the query param.
  // The next useEffect watches for queryParam changes and updates the visibility.
  // This way, loading the UI with the query param or using the browser back always shows the gallery.
  const setShowing = useCallback(
    (showing: boolean) => {
      const queryParams = new URLSearchParams(history.location.search);
      if (showing) {
        // When we append the query param to open the modal, we want to keep the previous history so going "back"
        // closes the modal.
        queryParams.set(TEMPLATE_GALLERY_PARAM, 'true');
        history.push({
          pathname: history.location.pathname,
          search: `?${queryParams.toString()}`,
          state: history.location.state,
        });
      } else {
        // When we hide the modal we just want to remove the query param, otherwise when we open one of the templates,
        // which also changes the URL, we end up with too many events on the history stack. We don't really need
        // to open the TG, close it, and allow "back" to reopen it at that point.
        queryParams.delete(TEMPLATE_GALLERY_PARAM);
        history.replace({
          pathname: history.location.pathname,
          search: `?${queryParams.toString()}`,
          state: history.location.state,
        });
      }
    },
    [history],
  );

  useEffect(() => {
    const params = new URLSearchParams(history.location.search);
    const isModalOpen = params.get(TEMPLATE_GALLERY_PARAM);
    setIsShowing(isModalOpen === 'true');
  }, [history.location.search]);

  return { showing, setShowing };
};
